import dashboard from './dashboard.json'
import warehouse from './warehouse.json'
const allDashboard = {
   dashboard,
   'dashboard-warehouse': warehouse,
}
export default allDashboard
